import { SET_HISTOGRAM_TYPE, SET_HISTOGRAM_SINGLE, SET_AUTO_REFRESH_LIST, SET_HIDDEN_LIST, SET_B2B_LIST, SET_B2B_COMPANY } from '../actions/histogram'

export function histogramData(
    state = {
			histogramType: undefined,
			histogramSubType: undefined,
			b2bList: [],
			b2bCompany: undefined,
			single: false,
			autoRefreshList: true,
			hiddenList: false
    }, action) {
	switch (action.type) {
		case SET_HISTOGRAM_TYPE:
			return Object.assign({}, state, {
				histogramType:action.histogramType,
				histogramSubType:action.histogramSubType,
				single:action.single
			})
		case SET_HISTOGRAM_SINGLE:
			return Object.assign({}, state, {
				single:action.single
			})
		case SET_AUTO_REFRESH_LIST:
			return Object.assign({}, state, {
				autoRefreshList:action.autoRefreshList
			})
		case SET_HIDDEN_LIST:
			return Object.assign({}, state, {
				hiddenList:action.hiddenList
			})
		case SET_B2B_LIST:
			return Object.assign({}, state, {
				b2bList: action.b2bList,
				b2bCompany: action.b2bCompany
			})
		case SET_B2B_COMPANY:
			return Object.assign({}, state, {
				b2bCompany:action.b2bCompany
			})
      	default:
        	return state
    }
}